import { useApi } from '@/src/composables/useApi';
import { IApiResponse } from '@/src/models/shared/common';
import { LocationItem, LocationMode } from '@/src/models/user-address';
import { withQuery } from './common';

export const fetchLocation = async <M extends LocationMode>(
  endpoint: string,
  mode: M,
  parentCode?: string
): Promise<{ value: string; label: string }[]> => {
  try {
    const api = useApi();
    const url = api.buildUrl(endpoint, 'healthcareIntelligence');
    const finalUrl = parentCode
      ? withQuery(url, { parent_code: parentCode })
      : url;

    const resp =
      await api.healthyoneTransaction.get<IApiResponse<LocationItem<M>[]>>(
        finalUrl
      );
    const data = resp.data as LocationItem<M>[];

    return data.map((item) => ({
      value: item[`${mode}_code` as keyof typeof item] as string,
      label: item[`${mode}_name` as keyof typeof item] as string,
    }));
  } catch (error) {
    return [];
  }
};
